import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathBeta = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M6 18.25a.75.75 0 0 0 1.5 0H6ZM9.75 6.5a.75.75 0 0 0 0 1.5V6.5Zm-3 11.75h.75V5H6v13.25h.75Zm6-14.05H12c0 .523-.154 1.111-.497 1.55-.32.411-.849.75-1.753.75V8c1.346 0 2.318-.536 2.935-1.326.594-.76.815-1.697.815-2.474h-.75Zm-6 .8h.75A2.5 2.5 0 0 1 10 2.5V1a4 4 0 0 0-4 4h.75ZM10 1.75v.75c.645 0 1.142.272 1.487.635.365.384.513.82.513 1.065h1.5c0-.704-.352-1.494-.925-2.098A3.507 3.507 0 0 0 10 1v.75Zm3.25 9.125h-.75a2.875 2.875 0 0 1-2.875 2.875v1.5A4.375 4.375 0 0 0 14 10.875h-.75ZM9.625 7.25V8a2.875 2.875 0 0 1 2.875 2.875H14A4.375 4.375 0 0 0 9.625 6.5v.75Zm0 7.25v-.75c-.944 0-1.735-.455-2.268-1.19L6.75 13l-.607.44c.785 1.083 2.009 1.81 3.482 1.81v-.75Z"
	})]
});
const ForwardRef = forwardRef(SvgMathBeta);
export { ForwardRef as ReactComponent };
